import React, { createContext, memo } from 'react';

import InputMain from './components/input-main';
import { InputHookType } from '../../type/chat.types';
import useInput from './hooks';

export const InputContext = createContext<InputHookType | null>(null);

const ChatInput = (props: any) => {
    // instance of input hook
    const inputHook: InputHookType = useInput(props);

    return (
        <InputContext.Provider value={inputHook}>
            <InputMain />
        </InputContext.Provider>
    );
};

export default memo(ChatInput);
